import authService from "../../../auth/AuthService";
import {
    addEditManualEntryRecordsActionTypes,
    apiActionsManualEntryRecords,
    ManualEntryRecordActionTypes
} from "../constants/ManualEntryRecordsActionConstants";

const getSelectedBillingRecords = (selectedRange, authToken) => ({
    type: apiActionsManualEntryRecords.GET_RECORDS,
    payload: {selectedRange, authToken}
});

const getOrgTenantCountries = (authToken) => ({
    type: apiActionsManualEntryRecords.GET_ORG_TENANT_COUNTRIES,
    payload: authToken
});

const setOrgTenantCountries = (orgTenantCountries) => ({
    type: addEditManualEntryRecordsActionTypes.SET_ORG_TENANT_COUNTRIES,
    payload: orgTenantCountries,
});

const setSelectedBillingRecords = (records) => ({
    type: ManualEntryRecordActionTypes.SET_RECORDS,
    payload: records
});

const setSelectedYear = (year) => ({
    type: ManualEntryRecordActionTypes.SET_YEAR,
    payload: year
});

const setSelectedMonth = (month) => ({
    type: ManualEntryRecordActionTypes.SET_MONTH,
    payload: month
});

const unmountMEBR = () => ({
    type: ManualEntryRecordActionTypes.CLEAR_MANUAL_BILLING_RECORDS
});

export function unmountBillingRecords() {
    return (dispatch) => {
        dispatch(unmountMEBR())
    }
}

export function selectYear(year) {
    return (dispatch) => {
        dispatch(setSelectedYear(year))
    }
}

export function selectMonth(month) {
    return (dispatch) => {
        dispatch(setSelectedMonth(month))
    }
}

export function getBillingRecords(selectedRange) {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(getSelectedBillingRecords(selectedRange, authToken))
    }
}

export function getFormOptions() {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(getOrgTenantCountries(authToken))
    }
}

export function setBillingRecords(records) {
    return (dispatch) => {
        dispatch(setSelectedBillingRecords(records))
    }
}

export function setFormOptions(orgTenantCountries) {
    return (dispatch) => {
        dispatch(setOrgTenantCountries(orgTenantCountries))
    }
}


// Add-Edit Action Constants
const toggleRecordsModal = (dateString) => ({
    type: addEditManualEntryRecordsActionTypes.TOGGLE_ADD_RECORDS_MODAL,
    payload: dateString
});

const toggleEditModal = (editRecordsObject) => ({
    type: addEditManualEntryRecordsActionTypes.TOGGLE_EDIT_RECORDS_MODAL,
    payload: editRecordsObject
});

const closeRecordsModal = () => ({
    type: addEditManualEntryRecordsActionTypes.CLOSE_RECORDS_MODAL,
});

const clearRecordsModal = () => ({
    type: addEditManualEntryRecordsActionTypes.CLEAR_RECORDS_MODAL,
});

const setMEBRForm = ({ name, value }) => ({
    type: addEditManualEntryRecordsActionTypes.SET_FORM_VALUE,
    payload: { name, value }
});

const setBillingType = ({ billingType } ) => ({
    type: addEditManualEntryRecordsActionTypes.SET_BILLING_RECORDS_TYPE,
    payload: { billingType }
});

const setBillingProduct = ({ billingProduct } ) => ({
    type: addEditManualEntryRecordsActionTypes.SET_BILLING_RECORDS_PRODUCT,
    payload: { billingProduct }
});

const setOrg = ({ org }) => ({
    type: addEditManualEntryRecordsActionTypes.SET_BILLING_RECORDS_ORG,
    payload: { org }
});

const setTenant = ({ tenant }) => ({
    type: addEditManualEntryRecordsActionTypes.SET_BILLING_RECORDS_TENANT,
    payload: { tenant }
});

const setCountry = ({ country }) => ({
    type: addEditManualEntryRecordsActionTypes.SET_BILLING_RECORDS_COUNTRY,
    payload: { country }
});

const validateRecord = (billingRecordObject, clearForm) => ({
    type: apiActionsManualEntryRecords.VALIDATE_BILLING_RECORD,
    payload: { billingRecordObject, clearForm }
});

const addRecord = (billingRecordObject, authToken, clearForm) => ({
    type: apiActionsManualEntryRecords.POST,
    payload: { billingRecordObject, authToken, clearForm }
});

const editRecord = (billingRecordObject, recordID, authToken) => ({
    type: apiActionsManualEntryRecords.PUT,
    payload: { billingRecordObject, recordID, authToken }
});

const deleteWarning = (recordID) => ({
    type: apiActionsManualEntryRecords.DELETE_WARNING_FOR_RECORD,
    payload: recordID
});

const deleteRecord = (recordID, selectedRange, authToken) => ({
    type: apiActionsManualEntryRecords.DELETE_CURRENT_RECORD,
    payload: { recordID, selectedRange, authToken }
});


// Add-Edit Actions
export function toggleDeleteWarningForRecord(recordID) {
    return (dispatch) => {
        dispatch(deleteWarning(recordID))
    }
}

export function deleteBillingRecord (recordID, selectedRange) {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(deleteRecord(recordID, selectedRange, authToken))
    }
}

export function validateBillingRecord(billingRecordObject, clearForm) {
    return async (dispatch) => {
        dispatch(validateRecord(billingRecordObject, clearForm))
    }
}

export function addNewRecord(billingRecordObject, clearForm) {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(addRecord(billingRecordObject, authToken, clearForm))
    }
}

export function updateRecord(billingRecordObject, recordID) {
    return async (dispatch) => {
        const authToken = await authService.idUser()
        dispatch(editRecord(billingRecordObject, recordID, authToken))
    }
}

export function toggleAddRecordsModal(dateString) {
    return (dispatch) => {
        dispatch(toggleRecordsModal(dateString))
    }
}

export function toggleEditRecordsModal(editRecordsObject) {
    return (dispatch) => {
        dispatch(toggleEditModal(editRecordsObject))
    }
}

export function closeBillingRecordsModal() {
    return (dispatch) => {
        dispatch(closeRecordsModal())
    }
}

export function clearBillingRecordsModal(clearForm) {
    return (dispatch) => {
        dispatch(clearRecordsModal(clearForm))
    } 
}

export function setBillingProductValue ({ billingProduct }) {
    return (dispatch) => {
        dispatch(setBillingProduct({ billingProduct }))
    }
}

export function setBillingTypeValue ({ billingType }) {
    return (dispatch) => {
        dispatch(setBillingType({ billingType }))
    }
}

export function setOrganizationValue({ org }) {
    return (dispatch) => {
        dispatch(setOrg({ org }))
    }
}

export function setTenantValue({ tenant }) {
    return (dispatch) => {
        dispatch(setTenant({ tenant }))
    }
}

export function setCountryValue({ country }) {
    return (dispatch) => {
        dispatch(setCountry({ country }))
    }
}

export function setMEBRecordsFormValues({ name, value }) {
    return (dispatch) => {
        dispatch(setMEBRForm({ name, value }))
    }
}
